import * as React from "react";
const SvgFiRrCloudShowers = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cloud-showers_svg__a)">
      <path
        fill="#062147"
        d="M14 24a1 1 0 0 1-1-1v-5a1 1 0 1 1 2 0v5a1 1 0 0 1-1 1m-8 0a1 1 0 0 1-1-1v-5a1 1 0 1 1 2 0v5a1 1 0 0 1-1 1m12-2a1 1 0 0 1-1-1v-5a1 1 0 1 1 2 0v5a1 1 0 0 1-1 1m-8 0a1 1 0 0 1-1-1v-5a1 1 0 1 1 2 0v5a1 1 0 0 1-1 1m-8-3.672a1 1 0 0 1-.777-.371A5.53 5.53 0 0 1 1.8 10.43a1 1 0 0 0 .345-.9 8.2 8.2 0 0 1-.033-2.89A7.945 7.945 0 0 1 8.5.139a8.05 8.05 0 0 1 8.734 4.438 1.04 1.04 0 0 0 .743.57A7.55 7.55 0 0 1 22.846 16.5a1 1 0 0 1-1.692-1.068 5.536 5.536 0 0 0-3.571-8.325 3.01 3.01 0 0 1-2.158-1.672A6 6 0 0 0 4.11 9.147a3 3 0 0 1-.964 2.763 3.52 3.52 0 0 0-.37 4.79A1 1 0 0 1 2 18.328"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cloud-showers_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCloudShowers;
